export const ShortArrowBottom = () => {
  return (
    <svg
      width="12"
      height="44"
      viewBox="0 0 12 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.77344 44L11.5469 34L-6.30618e-05 34L5.77344 44ZM5.77344 4L4.77344 4L4.77344 35L5.77344 35L6.77344 35L6.77344 4L5.77344 4Z"
        fill="white"
      />
      <rect
        x="2.77344"
        y="6"
        width="6"
        height="6"
        rx="3"
        transform="rotate(-90 2.77344 6)"
        fill="white"
      />
    </svg>
  );
};
